import { Alert, Button } from '@innovationnorway/cl-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ClusterContactDto } from 'src/api/v2';
import { useBoolean } from 'usehooks-ts';

type Props = {
  contacts: ClusterContactDto[];
};

const ExistingContactsNotification: React.FC<Props> = ({ contacts }) => {
  const { t: tResourceBase } = useTranslation('resourceBase');

  const showDuplicates = useBoolean();

  if (contacts.length === 0) {
    return null;
  }

  return (
    <Alert data-color="info" className="margin-bottom--3">
      <p>{tResourceBase('import.existsInResourceBase')}</p>
      <Button
        type="button"
        variant="tertiary"
        onClick={() => {
          showDuplicates.toggle();
        }}
        title={tResourceBase('showExisting')}
      >
        {tResourceBase('import.amount', { length: contacts.length })}
      </Button>
      |
      {showDuplicates.value ? (
        <ul>
          {contacts.map(({ id, firstName, lastName, emailAddress }) => (
            <li key={id}>
              {firstName} {lastName} ({emailAddress})
            </li>
          ))}
        </ul>
      ) : null}
    </Alert>
  );
};

export default ExistingContactsNotification;
